import { $ } from '../util/view';
import modal from './modal';
export default function ({ confirmText, declineText, footer, message, onConfirm = () => { }, onDecline = () => { }, title }) {
    return modal({
        body: $('div', { class: 'mol-ads-cmp--modal-message' }, message),
        footer: footer || [
            $('button', {
                'class': 'mol-ads-cmp--btn-secondary',
                'data-cmp-no-consent': true,
                'type': 'button'
            }, declineText)
                .click(onDecline),
            $('button', {
                'class': 'mol-ads-cmp--btn-primary',
                'data-cmp-no-consent': true,
                'type': 'button'
            }, confirmText)
                .click(onConfirm)
        ],
        title
    });
}
